import { BoxProps } from '@chakra-ui/react';
import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

import { CmBox } from '..';

type LinkProps = BoxProps & RouterLinkProps;
interface Props extends LinkProps {
  isDisabled?: boolean;
  isExternal?: boolean;
}

export const CmLink = ({
  isDisabled,
  isExternal,
  children,
  display = 'block',
  to,
  ...rest
}: Props): JSX.Element => {
  const handleClick = (e: React.MouseEvent) => {
    if (isDisabled) {
      e.preventDefault();
    }
  };
  const linkAttributes = (() => {
    if (isExternal) {
      return {
        href: to,
        target: '_blank',
        rel: 'noopener noreferrer',
        as: 'a',
      } as const;
    } else {
      return { to, as: RouterLink, onClick: handleClick } as const;
    }
  })();

  return (
    <CmBox onClick={handleClick} {...linkAttributes} {...{ display, ...rest }}>
      {children}
    </CmBox>
  );
};
